import Prism from 'prismjs';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

const PreWrapper = ({ isBlock, children, showLineNumbers }) => {
  return isBlock ? (
    <pre
      className={showLineNumbers ? 'line-numbers' : ''}
      data-testid="pre-element"
    >
      {children}
    </pre>
  ) : (
    children
  );
};

PreWrapper.defaultProps = {
  isBlock: false,
  showLineNumbers: false,
};

PreWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isBlock: PropTypes.bool,
  showLineNumbers: PropTypes.bool,
};

const Code = ({
  code,
  maxHeight,
  minHeight,
  language,
  highlight,
  isBlock,
  showLineNumbers,
}) => {
  // NOTE: For greater dynamic flexibility this could use `react-html-parser` with Prism.tokenize() without the need for bothering with the useEffect() hook
  const codeRef = useRef();

  useEffect(() => {
    if (codeRef && codeRef.current && highlight) {
      Prism.highlightElement(codeRef.current);
    }
  }, [codeRef, highlight]);

  useEffect(() => {
    if (codeRef && codeRef.current && showLineNumbers) {
      Prism.highlightElement(codeRef.current);
    }
  }, [codeRef, showLineNumbers]);

  const cssClass = highlight ? `language-${language}` : undefined;

  return (
    <div className="overflow-scroll" style={{ maxHeight, minHeight }}>
      <PreWrapper isBlock={isBlock} showLineNumbers={showLineNumbers}>
        <code className={cssClass} data-testid="code-element" ref={codeRef}>
          {typeof code === 'string' ? code.trim() : code}
        </code>
      </PreWrapper>
    </div>
  );
};

Code.defaultProps = {
  highlight: true,
  isBlock: false,
  language: 'js',
  maxHeight: '36rem',
  minHeight: '10rem',
  showLineNumbers: false,
};

// language types: if more are added, you must also adjust the babel config
// https://prismjs.com/#supported-languages
Code.propTypes = {
  code: PropTypes.string.isRequired,
  highlight: PropTypes.bool,
  isBlock: PropTypes.bool,
  language: PropTypes.oneOf(['bash', 'css', 'html', 'js']),
  maxHeight: PropTypes.string,
  minHeight: PropTypes.string,
  showLineNumbers: PropTypes.bool,
};

/*
const CodeInline = ({ code, language, highlight }) => {
  return <Code code={code} language={language} highlight={highlight} />;
};

const CodeBlock = ({ code, language, highlight }) => {
  return (
    <Code
      code={code}
      language={language}
      highlight={highlight}
      isBlock={true}
    />
  );
};
*/

export default Code;
/* export { CodeInline, CodeBlock }; */
